interface IconProps {
  color?: string
}

export function Micropayment({ color }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.65001C7.3884 3.65001 3.64998 7.38843 3.64998 12C3.64998 16.6116 7.3884 20.35 12 20.35C16.6116 20.35 20.35 16.6116 20.35 12C20.35 7.38843 16.6116 3.65001 12 3.65001ZM2.34998 12C2.34998 6.67046 6.67043 2.35001 12 2.35001C17.3295 2.35001 21.65 6.67046 21.65 12C21.65 17.3296 17.3295 21.65 12 21.65C6.67043 21.65 2.34998 17.3296 2.34998 12ZM8.2439 11.15C8.18242 11.4234 8.14998 11.7079 8.14998 12C8.14998 12.2921 8.18242 12.5766 8.2439 12.85H10.5C10.859 12.85 11.15 13.141 11.15 13.5C11.15 13.859 10.859 14.15 10.5 14.15H8.80471C9.49587 15.1759 10.6683 15.85 12 15.85C12.9186 15.85 13.7598 15.5294 14.4211 14.9938C14.7 14.7678 15.1093 14.8108 15.3353 15.0898C15.5612 15.3687 15.5183 15.778 15.2393 16.004C14.355 16.7203 13.2271 17.15 12 17.15C9.9213 17.15 8.13214 15.9212 7.3182 14.15H6.49998C6.14099 14.15 5.84998 13.859 5.84998 13.5C5.84998 13.141 6.14099 12.85 6.49998 12.85H6.91966C6.87382 12.5735 6.84998 12.2896 6.84998 12C6.84998 11.7104 6.87382 11.4265 6.91966 11.15H6.49998C6.14099 11.15 5.84998 10.859 5.84998 10.5C5.84998 10.141 6.14099 9.85001 6.49998 9.85001H7.3182C8.13214 8.07879 9.9213 6.85001 12 6.85001C13.2268 6.85001 14.3546 7.27888 15.2391 7.99476C15.5182 8.22061 15.5613 8.6299 15.3354 8.90894C15.1096 9.18798 14.7003 9.2311 14.4212 9.00525C13.7601 8.47014 12.9188 8.15001 12 8.15001C10.6683 8.15001 9.49587 8.82412 8.80471 9.85001H11.5C11.859 9.85001 12.15 10.141 12.15 10.5C12.15 10.859 11.859 11.15 11.5 11.15H8.2439Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
